import { styled } from '@mui/system';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';

export const FormCnt = styled('form')({
  padding: 0,
  margin: 0,
  maxWidth: '700px'
});

export const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2, 3),
  display: 'grid',
  gridGap: theme.spacing(2)
}));

export const ButtonCnt = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  padding: theme.spacing(2, 3)
}));

export const StyledButton = styled(Button)(({ theme }) => ({
  '&:not(:first-of-type)': {
    marginLeft: theme.spacing(2)
  }
}));
